<template>
  <div class="video-player">
    <AutoPlayVideo
      :src="videoSrc"
      :controls="true"         
      height=auto    
  />
  </div>
</template>

<script lang="ts">
import AutoPlayVideo from '@/components/AutoPlayVideo.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import HomePageMixin from '@/mixins/home-page-mixin'
import { HomePageStore } from '@/store/home-page/home-store'
import { Component, Mixins, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({
  components: {
    AutoPlayVideo,
  },
})
export default class BannerVideoSection extends Mixins(HomePageMixin) {
  homePageStore: PageStoreContract = getModule(HomePageStore, this.$store)

  @Ref('videoElement') readonly videoElement!: HTMLVideoElement
  @Ref('videoWrapper') readonly videoWrapper!: HTMLVideoElement

  get videoSrc(): string {
    return this.getElementMedia(0, 0)
  }
 
  async getHomePage(): Promise<void> {
    await this.homePageStore.getDataPage()
  }
  
  async mounted(): Promise<void> {
    if (!this.homePageStore.isLoading) {
      await this.getHomePage()
    }
  }
}
</script>

<style lang="scss">

</style>
